(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('LevelIbqDetailController', LevelIbqDetailController);

    LevelIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Level'];

    function LevelIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Level) {
        var vm = this;

        vm.level = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:levelUpdate', function(event, result) {
            vm.level = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
